import type { SupabaseClient } from '@supabase/supabase-js'
import type { RecoverSession } from '@/shared/domain'
import { isTransportFailure } from '@/shared/infra/http'

export class SupabaseRecoverSessionRepository {
  constructor(private readonly client: SupabaseClient) {}

  execute: RecoverSession = async () => {
    try {
      const { data, error } = await this.client.auth.refreshSession()
      if (!error && data.session) return data.session.access_token
      if (!isTransportFailure(error)) {
        await this.client.auth.signOut({ scope: 'local' })
      }
    } catch {
      return null
    }
    return null
  }
}
